<script>
export default {
  name: 'EmailBody',
  props: {
    mail: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <v-card
    class="ma-2"
    :class="
      $vuetify.dark ? 'card-dark beez-card ma-1' : 'card-light beez-card ma-1'
    "
  >
    <v-card-text>
      <v-text-field prefix="To" disabled v-if="mail.to" v-model="mail.to" />
      <v-text-field prefix="CC" disabled v-if="mail.cc" v-model="mail.cc" />
      <v-text-field prefix="Bcc" v-if="mail.bcc" disabled v-model="mail.bcc" />
      <v-text-field prefix="Subject" disabled v-model="mail.subject" />
      <v-flex xs12>
        <v-layout align-center justify-start row fill-height wrap>
          <template v-for="(file, key) in mail.attachments">
            <v-flex :key="key + 'file-flex'">
              <v-btn
                flat
                v-if="file.link.toString().startsWith('http')"
                class="beez-btn blue--text text-truncate"
                :href="file.link"
                target="_parent"
              >
                <span class="text-truncate">&nbsp;{{ file.name }}</span>
              </v-btn>
              <v-btn
                flat
                v-else
                class="beez-btn blue--text text-truncate"
                :href="'/api/core/dms/read/' + file.link"
                target="_parent"
              >
                <v-icon left>attachment</v-icon>
                <span class="text-truncate">&nbsp;{{ file.name }}</span>
              </v-btn>
            </v-flex>
          </template>
        </v-layout>
      </v-flex>
      <v-card flat class="card-light">
        <v-card-text>
          <iframe :srcdoc="mail.text" width="100%" height="400px" />
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
